import { useState } from 'react';

import data from '../../../package.json';
import postRatings from '../../api/ratings';
import Loader from '../../store/loader';
import { BrandButton } from '../Buttons/Buttons';
import MainLogo from '../MainLogo/MainLogo';

import AppRatingModalFormStars from './AppRatingModalFormStars';
import styles from './styles.module.scss';

const LOW_RATING_TEXT = 'Τι θα θέλατε να βελτιώσουμε;';
const HIGH_RATING_TEXT = 'Τι σας άρεσε περισσότερο;';

export default function AppRatingModal({ onSuccessfulSubmit }) {
  const [comment, setComment] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [labelText, setLabelText] = useState('');
  const [stars, setStars] = useState(0);
  const [isRatingSubmitted, setIsRatingSumbitted] = useState(false);

  async function _onClickSubmit() {
    Loader.addEvent('SENDING_RATING');

    const { error } = await postRatings({
      ratee: {
        model: 'app',
        client: `web/${data.version}`,
      },
      rating: stars,
      comment,
      saveRatingTimeForUser: true,
    });

    if (error) {
      setErrorMessage(error);
    } else {
      setIsRatingSumbitted(true);
      onSuccessfulSubmit();
    }

    Loader.removeEvent('SENDING_RATING');
  }

  function onChangeStars(value) {
    setStars(value);
    setLabelText(value > 3 ? HIGH_RATING_TEXT : LOW_RATING_TEXT);
  }

  return (
    <div className={styles.main}>
      <div className={styles.imgContainer}>
        <MainLogo />
      </div>
      {!isRatingSubmitted ? (
        <div>
          <p className={styles.text}>Πώς ήταν η εμπειρία των αγορών σας;</p>
          <p className={styles.smallerText}>Βαθμολογήστε μας!</p>
          <div className={styles.starsContainer}>
            <AppRatingModalFormStars value={stars} onChange={onChangeStars} />
          </div>
          {Boolean(stars) && (
            <label className={styles.textAreaContainer} htmlFor="comment">
              {isInputFocused && <span className={styles.labelText}>{labelText}</span>}
              <textarea
                className={styles.textArea}
                id="comment"
                name="comment"
                rows="1"
                wrap="soft"
                placeholder={!isInputFocused ? `${labelText} (προαιρετικά)` : ''}
                onChange={e => setComment(e.target.value)}
                onFocus={() => setIsInputFocused(true)}
                onBlur={() => setIsInputFocused(false)}
              />
            </label>
          )}

          {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}

          <div className={styles.btnContainer}>
            <BrandButton onClick={_onClickSubmit} disabled={!stars}>
              Υποβολή
            </BrandButton>
          </div>
        </div>
      ) : (
        <div>
          <p className={styles.text}>Ευχαριστούμε πολύ!</p>
          <p className={styles.smallerTextSpacing}>Με την βοήθειά σας γινόμαστε συνεχώς καλύτεροι!</p>
        </div>
      )}
    </div>
  );
}
